import React from 'react'
import './style.css'

const PorsAndConsCard = ({ content }) => {

    const ecommercePlatforms = [
        {
            platform: "Shopify",
            pros: "Launch <strong>2–3x faster</strong>, <strong>99.9%</strong> uptime, <strong>8,000+</strong> apps available",
            cons: "Limited backend flexibility (≈<strong>30%</strong> customization possible)",
            bestFor: "D2C brands, SMEs",
            image: "shopify-logo.png"
        },
        {
            platform: "WooCommerce",
            pros: "<strong>60%</strong> lower setup cost, <strong>100%</strong> open-source, <strong>50,000+</strong> plugins",
            cons: "Hosting & security fully user-managed (adds ~<strong>15%</strong> workload)",
            bestFor: "SMEs, content-first",
            image: "woocommerce.png"
        },
        {
            platform: "Magento",
            pros: "Supports <strong>500K+</strong> SKUs, multi-store scalability, <strong>100+</strong> integrations",
            cons: "Setup cost <strong>2–3x</strong> higher, longer deployment cycles",
            bestFor: "Enterprises, global",
            image: "magento.png"
        },
        {
            platform: "BigCommerce",
            pros: "Built-in B2B tools, <strong>99%</strong> uptime, SaaS maintenance-free",
            cons: "Customization limited to ~<strong>40%</strong> compared to headless setups",
            bestFor: "B2B/B2C mid-large",
            image: "bigcommerce.png"
        },
        {
            platform: "OpenCart",
            pros: "Up to <strong>70%</strong> lower cost, open-source, setup within days",
            cons: "Lacks advanced enterprise automation (–<strong>50%</strong> scalability)",
            bestFor: "Small retailers",
            image: "opencart.png"
        },
        {
            platform: "Salesforce CC",
            pros: "Native CRM sync, <strong>360°</strong> customer view, <strong>99.95%</strong> uptime",
            cons: "High licensing cost (avg. <strong>$4K–$8K/month</strong>)",
            bestFor: "Enterprise",
            image: "salesforce.png",
            imageWidth: 70
        },
        {
            platform: "Headless",
            pros: "Loads <strong>3–5x faster</strong>, <strong>100%</strong> API-driven, omnichannel-ready",
            cons: "Requires dev expertise (adds ~<strong>25–40%</strong> implementation time)",
            bestFor: "Innovative brands",
            image: "headless.png",
            imageWidth: 70
        },
        {
            platform: "Custom",
            pros: "<strong>100%</strong> control, tailor-fit architecture, scalable to any size",
            cons: "Long dev cycles (<strong>6–12 months</strong>), <strong>2–4x</strong> cost vs SaaS",
            bestFor: "Specialized industries",
            image: "custom-apps.png",
            imageWidth: 70
        }
    ];

    return (
        <>
            <div className="pros-and-cons-cards-wraper">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mb-5">
                            <h2 className="low-top-heading">Platform Comparison Pros & Cons</h2>
                            <p className="engagement-model-table-box-heading mb-0">Compare Ecommerce Platforms Before You Choose</p>
                            <p className="description-text mb-1">Explore the strengths, limitations, & best-fit use cases of leading eCommerce platforms to make an informed decision for your business.</p>
                        </div>

                        <div className="row">
                            <div className="col-md-12 remove-small-screes">
                                <img src="/images/life-at-bitsclan/mouse.svg" alt="CEO Image" style={{ position: 'absolute', top: '7rem', insetInlineEnd: '2rem', zIndex: '9', width: '20%',}} />
                            </div>
                        </div>

                        {ecommercePlatforms?.map((card, index) => {
                            return <div className="col-xl-6 col-lg-6 col-md-12 mb-4" key={index}>
                                <div className="engagement-model-pros-card">
                                    <div className="product-logo-box mb-4">
                                        <img src={`/images/ecommerce-page-icons/${card?.image}`} width={card?.imageWidth || 150} alt="" />
                                    </div>

                                    <div className="engagement-model-pros-card-text-box">
                                        <h3 className="sub-heading-text-for-table-cards"><i className="fa-solid fa-arrow-right text-icon-arrow-right"></i> Pros:</h3>
                                        <p className="description-text" dangerouslySetInnerHTML={{ __html: card?.pros }}></p>
                                    </div>
                                    <div className="engagement-model-pros-card-text-box">
                                        <h3 className="sub-heading-text-for-table-cards"><i className="fa-solid fa-arrow-right text-icon-arrow-right"></i> Cons:</h3>
                                        <p className="description-text" dangerouslySetInnerHTML={{ __html: card?.cons }}></p>
                                    </div>
                                    <div className="engagement-model-pros-card-text-box">
                                        <h3 className="sub-heading-text-for-table-cards"><i className="fa-solid fa-arrow-right text-icon-arrow-right"></i> Best For:</h3>
                                        <p className="description-text" dangerouslySetInnerHTML={{ __html: card?.bestFor }}></p>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default PorsAndConsCard